(() => {
  if (window.wtSilkPairingsPlacement) return;
  window.wtSilkPairingsPlacement = true;
  let timer;
  function place(attempt = 0) {
    clearTimeout(timer);
    const room = document.querySelector('wt-shop-room[data-silk-pairings]');
    const slot = document.getElementById('wt-silk-pairings-slot');
    const wrapper = room?.closest('.shopify-section');
    // Wait for the story to hydrate before adding independent section content.
    const hydrated = slot && Object.keys(slot).some(key => key.startsWith('__reactFiber'));
    if (wrapper && slot && hydrated) {
      if (wrapper.parentElement !== slot) slot.appendChild(wrapper);
      room.carouselResize?.observe(room.querySelector('[data-looks]'));
      return;
    }
    if (attempt < 100) timer = setTimeout(() => place(attempt + 1), 100);
  }
  place();
  document.addEventListener('shopify:section:load', () => place());
  document.addEventListener('shopify:section:reorder', () => place());
})();
